import type { PromptIconName } from '../types'
import SimpleChartIcon from '@shared/assets/icons/simple-chart.svg'
import BuildingIcon from '@shared/assets/icons/building.svg'
import BoxIcon from '@shared/assets/icons/box.svg'
import StaffTypeIcon from '@shared/assets/icons/staff-type.svg'
import CalendarIcon from '@shared/assets/icons/calendar.svg'
import SettingsIcon from '@shared/assets/icons/settings.svg'
import IdeaIcon from '@shared/assets/icons/idea.svg'

/* the icon of a prompt group by its `icon` name, for synchronous lookups */
export const iconRegistry: Readonly<
  Record<PromptIconName, typeof SimpleChartIcon>
> = {
  chart: SimpleChartIcon,
  building: BuildingIcon,
  box: BoxIcon,
  staff: StaffTypeIcon,
  calendar: CalendarIcon,
  settings: SettingsIcon,
  idea: IdeaIcon
}
